import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, of } from "rxjs";

import { NotificationService } from "../../_services/notification.service";
import { ProductFeatureActions } from ".";
import { ProductFeatureService } from "./product-feature.service";

@Injectable()
export class ProductFeatureEffects {
  private actions$ = inject(Actions);
  private productFeatureService = inject(ProductFeatureService);
  private notificationService = inject(NotificationService);

  getProductFeatures$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductFeatureActions.getProductFeatures),
      mergeMap(() =>
        this.productFeatureService.getProductFeatures().pipe(
          map(productFeatures =>
            ProductFeatureActions.getProductFeaturesSuccess({ productFeatures })
          ),
          catchError(error =>
            of(
              ProductFeatureActions.getProductFeaturesFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  enableProductFeature$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductFeatureActions.enableProductFeature),
      mergeMap(action =>
        this.productFeatureService.enableProductFeature(action.id).pipe(
          map(() =>
            ProductFeatureActions.enableProductFeatureSuccess({ id: action.id })
          ),
          catchError(error =>
            of(
              ProductFeatureActions.enableProductFeatureFailure({
                id: action.id,
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  disableProductFeature$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductFeatureActions.disableProductFeature),
      mergeMap(action =>
        this.productFeatureService.disableProductFeature(action.id).pipe(
          map(() =>
            ProductFeatureActions.disableProductFeatureSuccess({
              id: action.id,
            })
          ),
          catchError(error =>
            of(
              ProductFeatureActions.disableProductFeatureFailure({
                id: action.id,
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  productFeatureFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          ProductFeatureActions.getProductFeaturesFailure,
          ProductFeatureActions.enableProductFeatureFailure,
          ProductFeatureActions.disableProductFeatureFailure
        ),
        map(action => {
          this.notificationService.showError(`${action.type}: ${action.error}`);
        })
      ),
    { dispatch: false }
  );
}
